import Checkbox from "shared/components/inputs/checkbox/Checkbox";
import PropTypes from "prop-types";
import React from "react";
import ToggleButton from "shared/components/inputs/toggle-button/ToggleButton";

const DropdownListVariant = React.forwardRef(
    ({ isVariantToggle, label, ...rest }, ref) => {
        return (
            <>
                {isVariantToggle ? (
                    <ToggleButton label={[label, label]} {...rest} ref={ref} />
                ) : (
                    <Checkbox label={label} {...rest} ref={ref} />
                )}
            </>
        );
    }
);

DropdownListVariant.propTypes = {
    isVariantToggle: PropTypes.bool,
    label: PropTypes.string,
};

export default DropdownListVariant;
